<template>
  <el-card shadow="never">
    <div
      v-for="(item, index) in this.defaultList"
      :key="index"
      class="detail_item"
    >
      <span class="label">{{ item.label }}：</span>
      <span class="value no-wrap">{{ detail[item.key] }}</span>
    </div>
  </el-card>
</template>

<script>
import { getTncDetail } from './api'

export default {
  data() {
    // this.listMap = {
    //   AFS: [
    //     {
    //       label: 'Audited financial report within days',
    //       key: 'auditedFinancialReportWithinDays',
    //     },
    //   ],
    //   AREV: [
    //     {
    //       label: 'Complete annual review within days',
    //       key: 'completeAnnualReviewWithinDays',
    //     },
    //   ],
    //   QFS: [
    //     {
    //       label: 'Quarterly management accounts within days',
    //       key: 'quarterlyManagementAccountsWithinDays',
    //     },
    //   ],
    //   QREV: [
    //     {
    //       label: 'Complete Quarterly review within days',
    //       key: 'completeQuarterlyReviewWithinDays',
    //     },
    //   ],
    //   HFS: [
    //     {
    //       label: 'Half yearly management accounts within days',
    //       key: 'halfYearlyManagementAccountsWithinDays',
    //     },
    //   ],
    //   HREV: [
    //     {
    //       label: 'Complete half year review days',
    //       key: 'completeHalfYearReviewDays',
    //     },
    //   ],
    //   CMA: [
    //     {
    //       label: 'Parent name',
    //       key: 'parentName',
    //     },
    //     {
    //       label: 'Consolidated financials within days',
    //       key: 'consolidatedFinancialsWithinDays',
    //     },
    //     {
    //       label: 'Fiscal Period',
    //       key: 'fiscalPeriod',
    //     },
    //   ],
    //   PFIN: [
    //     {
    //       label: 'Parent name',
    //       key: 'parentName',
    //     },
    //     {
    //       label: 'Consolidated audited financials within days',
    //       key: 'consolidatedAuditedFinancialsWithinDays',
    //     },
    //   ],
    //   CI: [
    //     {
    //       label: 'Insurance cover %',
    //       key: 'insuranceCover',
    //     },
    //   ],
    //   TC: [
    //     {
    //       label: 'Max notice period days',
    //       key: 'maxNoticePeriodDays',
    //     },
    //   ],
    //   SBLC: [
    //     {
    //       label: 'Bank Name',
    //       key: 'bankName',
    //     },
    //     {
    //       label: 'Amount or %',
    //       key: 'amountOr',
    //     },
    //   ],
    //   BG: [
    //     {
    //       label: 'Bank Name',
    //       key: 'bankName',
    //     },
    //     {
    //       label: 'Amount or %',
    //       key: 'amountOr',
    //     },
    //     {
    //       label: 'Expiry date',
    //       key: 'expiryDateStr',
    //     },
    //   ],
    //   GPG: [
    //     {
    //       label: 'Guarantor name',
    //       key: 'guarantorName',
    //     },
    //     {
    //       label: 'Amount or %',
    //       key: 'amountOr',
    //     },
    //     {
    //       label: 'Expiry date',
    //       key: 'expiryDateStr',
    //     },
    //   ],
    //   PN: [
    //     {
    //       label: 'PN expiry date',
    //       key: 'pnExpiryDate',
    //     },
    //   ],
    //   GLPG: [
    //     {
    //       label: 'Personal guarantee from',
    //       key: 'personalGuaranteeFrom',
    //     },
    //   ],
    //   FCOV: [
    //     {
    //       label: 'Financial covenant definition',
    //       key: 'financialCovenantDefinition',
    //     },
    //   ],
    //   COVT: [
    //     {
    //       label: 'Covenants compliance check frequency',
    //       key: 'covenantsComplianceCheckFrequency',
    //     },
    //   ],
    //   CERT: [
    //     {
    //       label: 'Covenants compliance certificate within days',
    //       key: 'covenantsComplianceCertificateWithinDays',
    //     },
    //     {
    //       label: 'After financial closing',
    //       key: 'afterFinancialClosing',
    //     },
    //   ],
    //   PT1: [
    //     {
    //       label: 'Maximum payment terms',
    //       key: 'maximumPaymentTerms',
    //     },
    //   ],
    //   TRX: [
    //     {
    //       label: 'GCR Rating',
    //       key: 'gcrRating',
    //     },
    //     {
    //       label: 'Transactional rating',
    //       key: 'transactionalRating',
    //     },
    //   ],
    //   MSC1: [
    //     {
    //       label: 'Notes',
    //       key: 'notes',
    //     },
    //   ],
    //   DP: [
    //     {
    //       label: 'Baseline or Uplift',
    //       key: 'baselineOrUplift',
    //     },
    //     {
    //       label: 'Secured by %',
    //       key: 'securedBy',
    //     },
    //     {
    //       label: 'Type',
    //       key: 'typeStr',
    //     },
    //   ],
    //   POWC: [
    //     {
    //       label: 'Change of ownership to',
    //       key: 'changeOfOwnershipTo',
    //     },
    //   ],
    //   ARD: [
    //     {
    //       label: 'On credit hold if undisputed AR aged beyond',
    //       key: 'onCreditHoldIfUndisputedArAgedBeyond',
    //     },
    //   ],
    //   BCL: [
    //     {
    //       label: 'Baseline Amount',
    //       key: 'baselineAmount',
    //     },
    //     {
    //       label: 'Baseline validity',
    //       key: 'baselineValidity',
    //     },
    //   ],
    //   UPL: [
    //     {
    //       label: 'Uplift amount',
    //       key: 'upliftAmount',
    //     },
    //     {
    //       label: 'Valid untill',
    //       key: 'validUntill',
    //     },
    //   ],
    //   REF: [
    //     {
    //       label: 'Dealer codes covered',
    //       key: 'dealerCodesCovered',
    //     },
    //   ],
    //   SG: [
    //     {
    //       label: 'Supergroup name',
    //       key: 'supergroupName',
    //     },
    //   ],
    //   MSC2: [
    //     {
    //       label: 'Notes',
    //       key: 'notes',
    //     },
    //   ],
    //   MSC3: [
    //     {
    //       label: 'Notes',
    //       key: 'notes',
    //     },
    //   ],
    // }
    return {
      detail: {},
      defaultList: [
        {
          label: 'Tran#',
          key: 'bpmId',
        },
        {
          label: 'Active',
          key: 'actionStr',
        },
        {
          label: 'Code',
          key: 'conditionTypeStr',
        },
        {
          label: 'Description',
          key: 'desc',
        },
        {
          label: 'Type',
          key: 'tnCTypeStr',
        },
        {
          label: 'Expiry Date',
          key: 'tnCExpiryDate',
        },
        {
          label: 'Status',
          key: 'statusStr',
        },
        {
          label: 'Last Modified',
          key: 'updateTime',
        },
      ],
    }
  },
  mounted() {
    this._getTncDetail()
  },
  methods: {
    async _getTncDetail() {
      try {
        this.detail = await getTncDetail(this.$route.params.id)
        if (this.detail.desc.includes('&gt;')) {
          this.detail.desc = this.detail.desc.replace(/&gt;/, '>')
        }
        // const arr = this._addFilterList(this.detail.conditionTypeStr)
        // this.defaultList.unshift(...arr)
      } catch (e) {
        console.log(e)
      }
    },
    // _addFilterList(type) {
    //   return this.listMap[type]
    // },
  },
}
</script>

<style scoped lang="scss">
.detail_item {
  font-size: 14px;
  color: #000;
  line-height: 30px;
  font-weight: 400;
  margin-bottom: 10px;
  .label {
    display: inline-block;
    font-size: 14px;
    color: #000;
    line-height: 30px;
  }
  .value {
    font-size: 14px;
    color: #3a3f63;
    display: inline-block;
  }
  .no-wrap {
    max-width: 260px;
    vertical-align: bottom;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
